// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"609bd379","455":"7c2b87e3","977":"b54210b3"}[chunkId] + ".chunk.js";
};